import { render, staticRenderFns } from "./ReasonToBeBusyForm.vue?vue&type=template&id=65563327&"
import script from "./ReasonToBeBusyForm.vue?vue&type=script&lang=js&"
export * from "./ReasonToBeBusyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports